import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {SpinnerContentComponent} from "./spinner-content.component";



@observer
export class SpinnerComponent extends OrbitComponent {

    render() {

        if (!this.services.spinner.isSpinning) {
            return null;
        }

        return (
            <SpinnerContentComponent isMigrationSpinner={this.services.spinner.isTheMigrationSpinnerActive}/>
        )
    }
}
